<template>
	<div class="main-header mb-30">
		<div class="main-header-left">
			<h1 class="logo">
				<a href="http://mcdonalds.de">McDonald's</a>
			</h1>
			<nav class="main-nav">
				<ul class="main-nav-list">
					<li>
						<a href="https://www.mcdonalds.de/familien/junior-club">Junior Club</a>
					</li>
				</ul>
			</nav>
		</div>
		<div class="main-header-right">
			<div v-if="userIsLoggedIn">
				<a href="#" @click="logOut">Logout</a>
			</div>
			<div v-else>
				<router-link to="/login">Login</router-link>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'headerComponent',
		computed: {
			userIsLoggedIn: function() {
				return this.$store.state.loggedIn;
			}
		},
		methods: {
			logOut() {
				this.$store.commit('login', false);
				this.$store.commit('user', {email: '', password: ''});
				window.location = 'https://www.mcdonalds.de/familien/junior-club';
			}
		}
	};
</script>